"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var providerDefaultLogo = 'https://s3.amazonaws.com/uniteus-io-assets/logos/groups/default.png';
var _default = exports["default"] = providerDefaultLogo;